var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0267 0.999757C23.032 0.993207 24.0292 1.11806 24.9599 1.36702C25.8906 1.61597 26.7361 1.98402 27.447 2.44963C28.1579 2.91523 28.7198 3.46903 29.0999 4.07862C29.48 4.6882 29.6707 5.34133 29.6607 5.99976V5.99976",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28565 17.9998C8.27565 18.6582 8.46628 19.3113 8.84638 19.9209C9.22648 20.5305 9.78842 21.0843 10.4993 21.5499C11.2102 22.0155 12.0557 22.3835 12.9864 22.6325C13.9171 22.8814 14.9143 23.0063 15.9196 22.9998V22.9998",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.241 16H23.5535C23.1486 16 22.7602 15.9514 22.4739 15.8648C22.1876 15.7783 22.0267 15.6609 22.0267 15.5385V10.4615C22.0267 10.3391 22.1876 10.2217 22.4739 10.1352C22.7602 10.0486 23.1486 10 23.5535 10H34.241C34.6459 10 35.0343 10.0486 35.3206 10.1352C35.6069 10.2217 35.7678 10.3391 35.7678 10.4615V15.5385C35.7678 15.6609 35.6069 15.7783 35.3206 15.8648C35.0343 15.9514 34.6459 16 34.241 16Z",
    fill: "#CFF6E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3928 14H3.70525C3.30032 14 2.91198 13.9433 2.62565 13.8423C2.33932 13.7413 2.17847 13.6043 2.17847 13.4615V7.53846C2.17847 7.39565 2.33932 7.25869 2.62565 7.15771C2.91198 7.05673 3.30032 7 3.70525 7H14.3928C14.7977 7 15.186 7.05673 15.4724 7.15771C15.7587 7.25869 15.9195 7.39565 15.9195 7.53846V13.4615C15.9195 13.6043 15.7587 13.7413 15.4724 13.8423C15.186 13.9433 14.7977 14 14.3928 14Z",
    fill: "#CFF6E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3928 13.9998H3.70525C3.30032 13.9998 2.91198 13.8944 2.62565 13.7069C2.33932 13.5193 2.17847 13.265 2.17847 12.9998V1.99976C2.17847 1.73454 2.33932 1.48019 2.62565 1.29265C2.91198 1.10511 3.30032 0.999756 3.70525 0.999756H14.3928C14.7977 0.999756 15.186 1.10511 15.4724 1.29265C15.7587 1.48019 15.9195 1.73454 15.9195 1.99976V12.9998C15.9195 13.265 15.7587 13.5193 15.4724 13.7069C15.186 13.8944 14.7977 13.9998 14.3928 13.9998Z",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17847 9.99976H15.9195",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.241 22.9998H23.5535C23.1486 22.9998 22.7602 22.8944 22.4739 22.7069C22.1876 22.5193 22.0267 22.265 22.0267 21.9998V10.9998C22.0267 10.7345 22.1876 10.4802 22.4739 10.2926C22.7602 10.1051 23.1486 9.99976 23.5535 9.99976H34.241C34.6459 9.99976 35.0343 10.1051 35.3206 10.2926C35.6069 10.4802 35.7678 10.7345 35.7678 10.9998V21.9998C35.7678 22.265 35.6069 22.5193 35.3206 22.7069C35.0343 22.8944 34.6459 22.9998 34.241 22.9998Z",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0267 18.9998H35.7678",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferMoney);
export default __webpack_public_path__ + "static/media/transferMoney.782353f21a73b0d86bf965b4eacbfca0.svg";
export { ForwardRef as ReactComponent };